import { projectsApiClient } from "../common/axiosInstanceProjects";
import { handleAxiosError } from "../common/handleAxiosError";

export const getProjectById = async (projectId: number) => {
  try {
    const response = await projectsApiClient.get(`/projects/${projectId}`);
    return response?.data;
  } catch (error) {
    handleAxiosError(error, "Error al obtener el proyecto");
  }
};